// ** React Imports
import { useState, useEffect } from 'react';
import classnames from 'classnames';
import * as Icon from 'react-feather';
import { useDispatch, batch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Autocomplete from '../CustomComponent/autocomplete';
import '../../styles/_search.scss'

const NavbarSearch = ({ setOpenSearchBar, openSearchBar }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const project =
    location.pathname.split('/')[2] === 'sbpdcl'
      ? 'ipcl'
      : location.pathname.split('/')[2];

  const [userInputParameter, setUserInputParameter] = useState('');

  const [selectedOption, setSelectedOption] = useState('meter');

  // const [search, response] = useLazyGISMeterSearchQuery();

  const searchMeter = () => {
    const params = {
      project: project,
      unique_id: userInputParameter,
      asset_type: selectedOption,
    };
    //Get searched Meter Info
    // search(params);
  };


  const userInputFun = (val) => {
    setUserInputParameter(val);
  };

  // ** Function to close search on ESC & ENTER Click
  const onKeyDown = (e) => {
    if (e.keyCode === 27 || e.keyCode === 13) {
      // console.log(e.keyCode)
      setTimeout(() => {
        // setNavbarSearch(false);
        if (
          userInputParameter === undefined ||
          userInputParameter.length <= 0
        ) {
          // Do Nothing
        } else {
          searchMeter();
        }
      }, 1);
    }
  };
  const handleSearchIconClicked = () => {
    if (userInputParameter === undefined || userInputParameter.length <= 0) {
      //do Nothing
    } else {
      searchMeter();
    }
  };

  return (


    <div className={classnames('search-input d-flex justify-content-between', { open: true })} >
      <div className='search-input-icon '>
        <Icon.Search />
      </div>
      {openSearchBar ? (
        <>
          <Autocomplete
            className='form-control'
            filterKey='title'
            filterHeaderKey='groupTitle'
            grouped={true}
            placeholder='Search for Meter Number , BP Number , CA Number'
            autoFocus={true}
            onKeyDown={onKeyDown}
            userInputFun={userInputFun}
          />
        </>
      ) : null}

      <div className='search-input-close'>
        <Icon.X
          className='ficon close-icon onIconHover'
          onClick={e => {
            e.stopPropagation()
            setOpenSearchBar(false)
            handleSearchIconClicked()
          }}
        />
      </div>
    </div>

  )
};

export default NavbarSearch;
